"use client";
import React from "react";
import styles from "./FeatureHero.module.css";

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

interface FeatureHeroProps {
  heading: string;
  description: string;
}

const FeatureHero: React.FC<FeatureHeroProps> = ({ heading, description }) => {
  return (
    <section className={`${styles.heroSection} bg-dark`}>
      <div className="container">
        <div className={styles.centerBox}>
          <h1 className={styles.mainHeading}>{heading}</h1>
          <p className={styles.description}>{description}</p>

          {/* <div className={styles.buttonRow}>
 
            <button className={styles.btnPrimary}>
              Get Started 
              <FontAwesomeIcon icon={faArrowRight} className={styles.btnIcon} />
            </button> 
            <button className={styles.btnSecondary}>
              Learn More 
              <FontAwesomeIcon icon={faArrowRight} className={styles.btnIcon} />
            </button>

          </div> */}
        </div>
      </div>
    </section>
  );
};

export default FeatureHero;
